import { auth, db } from "./firebase";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  sendEmailVerification,
  updatePassword,
  signInWithPopup,
  GoogleAuthProvider,
} from "firebase/auth";
import { 
  doc, 
  setDoc, 
  getDoc, 
  serverTimestamp 
} from "firebase/firestore";

export const doCreateUserWithEmailAndPassword = async (email, password, userData, collection) => {
  const userCredential = await createUserWithEmailAndPassword(auth, email, password);
  const user = userCredential.user;
  
  // Create user document in Firestore
  await setDoc(doc(db, collection, user.uid), {
    ...userData,
    createdAt: new Date()
  });

  return userCredential;
};


export const doSignInWithEmailAndPassword = (email, password) => {
  return signInWithEmailAndPassword(auth, email, password);
};

export const doSignInWithGoogle = async () => {
  try {
    const provider = new GoogleAuthProvider();
    const userCredential = await signInWithPopup(auth, provider);
    const user = userCredential.user;
    
    const localBusinessDocRef = doc(db, "localbusiness", user.uid);
    const localBusinessDoc = await getDoc(localBusinessDocRef);
    if (localBusinessDoc.exists()) {
      return userCredential;
    }

    const businessDocRef = doc(db, "businesses", user.uid);
    const businessDoc = await getDoc(businessDocRef);
    if (businessDoc.exists()) {
      return userCredential;
    }
    
    // Check if user document exists in Firestore
    const userDocRef = doc(db, "users", user.uid);
    const userDoc = await getDoc(userDocRef);
    
    // If user document doesn't exist, create it with default values
    if (!userDoc.exists()) {
      const userData = {
        email: user.email,
        name: user.displayName || '',
        phone: user.phoneNumber || '',
        community: '',  // Default empty community
        role: 'user',
        createdAt: serverTimestamp()
      };
      
      // Create the user document
      await setDoc(userDocRef, userData);
    }
    
    return userCredential;
  } catch (error) {
    console.error("Error during Google sign-in:", error);
    throw error;
  }
};

export const doSignOut = () => {
  return auth.signOut();
};

export const doPasswordReset = (email) => {
  return sendPasswordResetEmail(auth, email);
};

export const doPasswordChange = (password) => {
  return updatePassword(auth.currentUser, password);
};

export const doSendEmailVerification = () => {
  return sendEmailVerification(auth.currentUser, {
    url: `${window.location.origin}/home`,
  });
};